// import {Spin} from 'antd';
import React from 'react';
import Loader from 'halogenium/lib/PulseLoader';

export default function () {
    return <Loader loading color="#007bff" size="16px" margin="2px"/>;
}

// export default Spin;
